<template>
  <task-index typeTitle="校正"></task-index>
</template>

<script>
import taskIndex from '../components/taskIndex.vue';
export default {
  components: {
    taskIndex
  }
}
</script>
